<script>
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer } from 'src/utils'
import { mapActions, mapMutations, mapState } from "vuex";
import { notify } from 'src/plugins/notify'

const moment = require('moment')

export default {
  name: "UnscheduledClasses",
  data() {
    return {
      maximized: false,
      startDate: null,
      endDate: null,
      lastRunTime: null,
      debounceMs: 1000,
    };
  },
  computed: {
    ...mapState({
      unscheduledClassesModal: s => s.shared.unscheduledClassesModal,
    })
  },
  valdiations(){
    return {}
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("reports", ["changeState"]),
    ...mapActions("reports", [ "generateUnscheduledClassesReport"]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    runReport () {
      // debounce
      if (this.lastRunTime) {
        if ((new Date().getTime() - this.lastRunTime) < this.debounceMs) {
          return
        }
      }

      this.lastRunTime = new Date().getTime()

      if (!this.startDate || !this.endDate) {
        notify.create({ message:'Please enter start and end date', type:'negative' })
        return
      }

      const payload = {
        end_date: moment(this.endDate).format('YYYY-MM-DD'),
        start_date: moment(this.startDate).format('YYYY-MM-DD'),
      }

      this.generateUnscheduledClassesReport(payload)
      .then(response => {
        if(response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)],
            { type: 'application/octet-stream' }),
            this.getTitle(this.startDate, this.endDate),
          )
        }
      })
    },
    getTitle(start, end) {
      const formatTitleDate = (d) => d.split('T')[0]
      const title_start = start ? formatTitleDate(start) : '2023-1-1'
      const title_end = end ? formatTitleDate(end) : '2100-1-1'
      const title = `Agencies for ${title_start}-${title_end}`

      return `${title}.xlsx`
    },
  }
};
</script>

<template>
  <q-modal class="sl-modal"
  id="unscheduledClassesModal"
  :maximized="maximized"
  :value="unscheduledClassesModal"
  @hide="closeModal('unscheduledClasses')"
  >
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        <q-icon name="fa fa-clock-o" />Unscheduled Classes Report
      </q-toolbar-title>
      <q-icon @click.native="closeModal('unscheduledClasses')" name="clear" />
    </q-toolbar>
    <div style="padding:40px 20px">
      <div class="sl-row">
        <div class="sl-col-12">
            <p style="max-width:350px; margin:0 auto" class="text-center">This report shows all agencies who do <b>not</b> have classes scheduled within the specified date range.</p>
        </div>
      </div>
      <div class="sl-row" style="margin:0">
        <div class="sl-col-6">
          <q-datetime stack-label="Start Date *" v-model="startDate" />
        </div>
        <div class="sl-col-6">
          <q-datetime stack-label="End Date *" v-model="endDate" />
        </div>
      </div>
    </div>
      <q-toolbar slot="footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn color="green" @click.native="runReport()" icon="fa fa-play" label="Run" />&nbsp;
        <q-btn outline color="faded" @click.native="closeModal('unscheduledClasses')" label="Cancel" />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
</style>